function currency(num: number, decimal = 2) {
  try {
    return num
      .toFixed(decimal) // always two decimal digits
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  } catch (error) {
    return 0
  }
}

function date(dt: Date) {
  try {
    return new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(dt)
  } catch (error) {
    return null
  }
}

function dateTime(dt: Date) {
  const newDate = new Date(dt)
  try {
    return new Intl.DateTimeFormat('en', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(newDate)
  } catch (error) {
    return null
  }
}

const formatter = { currency, date, dateTime }

export default formatter
